/* eslint-disable */
const version = VERSION;

console.log(`Running ver: ${VERSION}`)



// WEBPACK FOOTER //
// ./app/scripts/components/version.js